var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgActiveControlDisabled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_854_11967)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.571289,
    width: 40,
    height: 20,
    rx: 10,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5713,
    y: 2,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#AFAFAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_854_11967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 20,
    fill: "white",
    transform: "translate(0.571289)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActiveControlDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ActiveControlDisabled.dd287cb0.svg";
export { ForwardRef as ReactComponent };